import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './AgeVerificationModal.css';

const AgeVerificationModal = ({ isOpen, onConfirm, onDecline }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            className="age-verification-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />
          <div className="age-verification-modal-wrapper">
            <motion.div
              className="age-verification-modal"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.4, ease: 'easeOut' }}
            >
            <div className="age-verification-content">
              <div className="age-verification-icon">
                <span>🔞</span>
              </div>
              <h2>Age Verification</h2>
              <p className="age-verification-text">
                The content of this site is exclusively for persons aged 18 and over. Please observe the legal requirements of your country.
              </p>
              <p className="age-verification-question">
                Are you at least 18 years old?
              </p>
              <div className="age-verification-buttons">
                <motion.button
                  className="age-verification-button confirm"
                  onClick={onConfirm}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Yes, I am 18+
                </motion.button>
                <motion.button
                  className="age-verification-button decline"
                  onClick={onDecline}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  No
                </motion.button>
              </div>
              <p className="age-verification-disclaimer">
                By confirming, you declare that you are of legal age and accept the terms of use.
              </p>
            </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default AgeVerificationModal;
